export function isHoneypotTripped(value: string): boolean {
    return value.trim().length > 0;
}

export function honeypotRejectDelayMs(): number {
    return 800 + Math.floor(Math.random() * 700);
}
